var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('member-edit',{attrs:{"detail":_vm.work_detail,"need-service":this.service,"handle-image":_vm.handleUploadImage},on:{"handle-submit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }